import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/constants';
import { MarketService } from 'src/app/providers/services/market.service';
import { Market } from 'src/app/storage/models/market.model';

@Component({
    selector: 'app-select-market',
    templateUrl: './select-market.component.html',
    styleUrls: ['./select-market.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectMarketComponent implements OnInit, OnDestroy {
  translations: any;

  markets: Market[] = [];
  selectedMarket: Market | null = null;
  marketsSubscription: Subscription;

  constructor(
    private translateService: TranslateService,
    private marketService: MarketService
  ) { }

  async ngOnInit(): Promise<void> {
    this.translations = await this.translateService.get('REGIONS').toPromise();

    this.marketsSubscription = this.marketService.markets$.subscribe(async markets => {
      if (markets) {
        // Filter on listed markets
        this.markets = Object.keys(CONSTANTS.REGIONS)
                      .map(key => markets.find(market => market.marketname === CONSTANTS.REGIONS[key]))
                      .filter(market => market != null);

        const defaultMarket = this.marketService.getDefaultMarketname();
        const selectedMarket = this.markets.find(market => market.marketname === defaultMarket)
          ?? this.markets[0]
          ?? null;
        if (selectedMarket) {
          this.selectMarket(selectedMarket);
        } else {
          this.selectedMarket = null;
          this.marketService.selectedMarket$.next(null);
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.marketsSubscription) { this.marketsSubscription.unsubscribe(); }
  }

  getMarketName(market: Market): string {
    const translationKey = Object.keys(this.translations).find(key => CONSTANTS.REGIONS[key] === market.marketname);
    return translationKey ? this.translations[translationKey] : ''; 
  }

  selectMarket(market: Market): void {
    if (!market) { return; }

    this.selectedMarket = market;
    this.marketService.setDefaultMarketname(market.marketname);
    this.marketService.selectedMarket$.next(market);
  }
}
